import React, { useState } from 'react';
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link as RouterLink, Outlet, useLocation } from 'react-router-dom';
import TrustStrip from '../components/TrustStrip';
import LogoWatermark from './LogoWatermark';
import MobileDrawer from './MobileDrawer';
import MobileThemeToggle from './MobileThemeToggle';

const logoUrl = `${process.env.PUBLIC_URL}/logo_.svg`;

export default function MobileLayout() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation();
  const showTrustInHeader =
    location.pathname === '/m' || location.pathname === '/m/';

  return (
    <Box
      sx={{
        height: '100dvh',
        maxHeight: '100dvh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default',
        position: 'relative',
      }}
    >
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          bgcolor: 'background.paper',
          color: 'text.primary',
          borderBottom: 1,
          borderColor: 'divider',
          zIndex: 10,
        }}
      >
        <Toolbar sx={{ minHeight: 56, px: 1.5, gap: 0.5 }}>
          <Box
            component={RouterLink}
            to="/m"
            sx={{
              display: 'flex',
              alignItems: 'center',
              flex: 1,
              minHeight: 48,
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <Box
              component="img"
              src={logoUrl}
              alt="Rahoituskanava"
              sx={{ height: 36, width: 'auto', maxWidth: 160 }}
            />
          </Box>
          <MobileThemeToggle />
          <IconButton
            edge="end"
            aria-label="Valikko"
            onClick={() => setDrawerOpen(true)}
            sx={{ minWidth: 48, minHeight: 48 }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
        {showTrustInHeader && (
          <Box sx={{ px: 1.5, pb: 1, pt: 0 }}>
            <TrustStrip variant="header" />
          </Box>
        )}
      </AppBar>

      <Box
        component="main"
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          zIndex: 1,
          pb: 'env(safe-area-inset-bottom, 0px)',
        }}
      >
        <LogoWatermark />
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
          }}
        >
          <Outlet />
        </Box>
      </Box>

      <MobileDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
    </Box>
  );
}
